<template>
    <div style="height: 100%;width: 100%;overflow: auto;" class="beautymemberinfo">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-tabs type="border-card" v-model="active" @tab-click="handleClick">
            <el-tab-pane label="资料">
                <el-descriptions class="margin-top" :column="2" size="mini"  border>
                    <el-descriptions-item>
                        <template slot="label">
                          入米兰会员
                        </template>
                        {{mldate}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                          首次到美容部
                        </template>
                        {{beautydate}}
                    </el-descriptions-item>
                    <el-descriptions-item :span="2">
                        <template slot="label">
                          负责美容师
                        </template>
                        <span v-for="(item,key) in beautyHeader" :key="key">
                            {{item.staffname}}
                        </span>
                    </el-descriptions-item>
                    <!--<el-descriptions-item :span="2" label="最新的预约">
                        <div v-if="orderInfo.roomname">
                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="24">房间:{{orderInfo.roomname}}</el-col>
                                <el-col :span="24" class="custBtn" style="text-align: right;"></el-col>
                            </el-row>
                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="24">姓名:{{orderInfo.membername}}</el-col>
                                <el-col :span="24">卡号:{{orderInfo.cardnumber}}</el-col>
                                <el-col :span="24">性别:<span v-if="orderInfo.sex==1">男</span><span v-else>女</span></el-col>
                            </el-row>
                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="24">日期:{{orderInfo.accountdate}}</el-col>
                            </el-row>
                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="24">时间:{{orderInfo.times.split(",")[0]}}-{{orderInfo.times.split(",")[orderInfo.times.split(",").length-1]}}</el-col>
                            </el-row>
                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="24">
                                    需要做的项目:<span v-for="(detal,index) in orderInfo.orderDetals">({{detal.projectname}})</span>
                                </el-col>
                            </el-row>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item :span="2" label="最新消费">
                        <div v-if="beautySaleLogVo.accountdate">日期:{{$moment(beautySaleLogVo.accountdate).format('YYYY-MM-DD')}}</div>
                        <div v-for="(item,key) in beautySaleLogVo.cardTransactionHistories" :key="key">
                            {{item.projectname}}
                        </div>
                    </el-descriptions-item>-->
                </el-descriptions>
                <!--<el-divider>账户余额</el-divider>
                <el-descriptions class="margin-top" :column="1" border size="mini">
                    <el-descriptions-item v-for="(item,key) in cardAccounts" :key="key" v-if="item.balance>0">
                        <template slot="label">
                          <i class="el-icon-money"></i>
                          {{item.accountname}}
                        </template>
                        {{item.balance}}元
                    </el-descriptions-item>
                </el-descriptions>-->
                <el-divider>疗程剩余情况</el-divider>
                <el-descriptions class="margin-top" :column="2" border size="mini">
                    <el-descriptions-item v-for="(item,key) in cardCourses" :key="key">
                        <template slot="label">
                          {{item.projectname}}
                        </template>
                        {{item.restnumber}}
                    </el-descriptions-item>
                </el-descriptions>
                <!--<el-divider>买过已经用完的项目</el-divider>
                <el-row>
                    <el-col :span="24" v-for="(item,key) in projectTypes" style="padding-bottom: 5px;" :key="key">
                        <el-form label-width="140px" class="myfrom" @submit.native.prevent>
                            <el-form-item label="用完了为什么不续">
                                <el-tag><span v-if="item.value2=='' || item.value2==null">{{item.value1}}</span><span>{{item.value2}}</span></el-tag>
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="item.whyAdd.remarks" @change="saveWhyAdd(item)"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-divider>体验过没有买的项目</el-divider>
                <el-row>
                    <el-col :span="24" v-for="(item,key) in projectExperienceTypes" style="padding-bottom: 5px;" :key="key">
                        <el-form label-width="140px" class="myfrom" @submit.native.prevent>
                            <el-form-item label="体验了为什么不买">
                                <el-tag>
                                    <span v-if="item.value2=='' || item.value2==null">{{item.value1}}</span><span>{{item.value2}}</span>
                                </el-tag>
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="item.whyAdd.remarks" @change="saveWhyBuy(item)"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>-->
                <!--<el-divider v-show="false" style="display: none;">没有体验过的项目</el-divider>-->
                <el-row v-show="false">
                    <el-col :span="6" v-for="(item,key) in notExperiences" style="padding-bottom: 5px;" :key="key">
                        <el-tag>
                            <span v-if="item.value2=='' || item.value2==null">{{item.value1}}</span><span>{{item.value2}}</span>
                        </el-tag>
                    </el-col>
                </el-row>
                <el-divider>客户基本资料</el-divider>
                <el-descriptions class="margin-top" :column="2" border size="mini" direction="vertical">
                    <el-descriptions-item  label="姓名">{{memberInfo.membername}}</el-descriptions-item>
                    <el-descriptions-item  label="昵称">
                        <el-input placeholder="请输入内容" v-model="memberInfo.nickname" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="性别"><span v-if="memberInfo.sex==1">男</span><span v-else>女</span></el-descriptions-item>
                    <el-descriptions-item label="职业">
                        <el-input placeholder="请输入内容" v-model="memberInfo.pos" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="出生日期">
                        <el-date-picker  v-model="memberInfo.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="mini" style="width: 100%;" @change="updateMemberInfo"></el-date-picker>
                    </el-descriptions-item>
                    <el-descriptions-item label="年龄">
                        {{memberInfo.age}}
                    </el-descriptions-item>
                    <el-descriptions-item label="年收入">
                        <el-input type="number" placeholder="请输入内容" v-model="memberInfo.duty" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>

                </el-descriptions>
                <el-descriptions :column="1" direction="vertical" border size="mini">
                    <!--<el-descriptions-item label="来美容部的方式">
                        <el-radio-group v-model="memberInfo.beautysource" @change="updateMemberInfo">
                            <el-radio :label="item.constantid" v-for="(item,key) in membersources" :key="key">{{item.constantname}}</el-radio>
                        </el-radio-group>
                        <el-input placeholder="请输入内容" v-model="memberInfo.beautysource" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>-->
                    <el-descriptions-item label="家庭住址" >
                        <el-input placeholder="请输入内容" v-model="memberInfo.address" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                </el-descriptions>

                <el-divider>客户家庭成员</el-divider>
                <el-descriptions class="margin-top" :column="1" border size="mini" direction="vertical">
                    <el-descriptions-item label="婚姻:婚否,夫妻感情如何,老公是做什么的等等">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" placeholder="请输入内容" v-model="memberInfo.partner" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="小孩:年龄,性别,学校,谁带,小孩让他的困扰等等">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" placeholder="请输入内容" v-model="memberInfo.child" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item label="父母:(父母是做什么),其他关联的人等等">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" placeholder="请输入内容" v-model="memberInfo.father" style="width: 100%;" size="mini" @change="updateMemberInfo"></el-input>
                    </el-descriptions-item>
                </el-descriptions>
                <el-form label-position="top" :model="memberInfo" @submit.native.prevent>
                    <el-form-item label="客户的辉煌事迹,人生履历">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="memberInfo.lifeexperience" @change="updateMemberInfo"></el-input>
                    </el-form-item>
                    <el-form-item label="来米兰之前在哪里做养生">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="memberInfo.spaexperience" @change="updateMemberInfo"></el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="问题">
                        <el-form label-position="top" :model="skinTesting" class="pfzk" @submit.native.prevent>
                            <el-form-item>
                                <el-divider>皮肤状况</el-divider>
                                <el-checkbox-group v-model="skinTesting.skinzkarray" v-show="false">
                                    <el-checkbox label="小于实际年龄"></el-checkbox>
                                    <el-checkbox label="大于实际年龄"></el-checkbox>
                                    <el-checkbox label="符合实际年龄"></el-checkbox>
                                    <el-checkbox label="痘痘"></el-checkbox>
                                    <el-checkbox label="紧实"></el-checkbox>
                                    <el-checkbox label="松弛"></el-checkbox>
                                    <el-checkbox label="嫩滑"></el-checkbox>
                                    <el-checkbox label="粗糙"></el-checkbox>
                                    <el-checkbox label="干燥"></el-checkbox>
                                    <el-checkbox label="雀斑"></el-checkbox>
                                    <el-checkbox label="黄褐斑"></el-checkbox>
                                    <el-checkbox label="红润"></el-checkbox>
                                    <el-checkbox label="暗黑"></el-checkbox>
                                    <el-checkbox label="黄气"></el-checkbox>
                                    <el-checkbox label="光泽"></el-checkbox>
                                    <el-checkbox label="弹性"></el-checkbox>
                                    <el-checkbox label="洁白"></el-checkbox>
                                    <el-checkbox label="苍白"></el-checkbox>
                                    <el-checkbox label="中干性"></el-checkbox>
                                    <el-checkbox label="有油性"></el-checkbox>
                                    <el-checkbox label="敏感性"></el-checkbox>
                                    <el-checkbox label="混合型"></el-checkbox>
                                    <el-checkbox label="毛孔粗大"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item>
                                <el-input type="textarea" placeholder="请描述客户在乎的皮肤问题" :autosize="{ minRows: 2, maxRows: 100}" v-model="skinTesting.skinzkother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>额头</el-divider>
                                <el-checkbox-group v-model="skinTesting.etarray">
                                    <el-checkbox label="深纹"></el-checkbox>
                                    <el-checkbox label="浅纹"></el-checkbox>
                                    <el-checkbox label="粉刺"></el-checkbox>
                                    <el-checkbox label="油脂"></el-checkbox>
                                    <el-checkbox label="暗疮印"></el-checkbox>
                                    <el-checkbox label="暗疮疤洞"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="skinTesting.etother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>眼部</el-divider>
                                <el-checkbox-group v-model="skinTesting.ybarray">
                                    <el-checkbox label="眼袋"></el-checkbox>
                                    <el-checkbox label="黑眼圈"></el-checkbox>
                                    <el-checkbox label="鱼尾纹"></el-checkbox>
                                    <el-checkbox label="上眼睑松弛"></el-checkbox>
                                    <el-checkbox label="下眼睑松弛"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="skinTesting.ybother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>面颊</el-divider>
                                <el-checkbox-group v-model="skinTesting.mjarray">
                                    <el-checkbox label="干纹"></el-checkbox>
                                    <el-checkbox label="红血丝"></el-checkbox>
                                    <el-checkbox label="斑点块"></el-checkbox>
                                    <el-checkbox label="痘痘"></el-checkbox>
                                    <el-checkbox label="痘印"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="skinTesting.mjother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>鼻子</el-divider>
                                <el-checkbox-group v-model="skinTesting.bzarray">
                                    <el-checkbox label="黑头多"></el-checkbox>
                                    <el-checkbox label="毛孔粗大"></el-checkbox>
                                    <el-checkbox label="凹凸洞"></el-checkbox>
                                    <el-checkbox label="斑点"></el-checkbox>
                                    <el-checkbox label="痘痘"></el-checkbox>
                                    <el-checkbox label="多油"></el-checkbox>
                                    <el-checkbox label="浅纹"></el-checkbox>
                                    <el-checkbox label="深纹"></el-checkbox>
                                    <el-checkbox label="紧实"></el-checkbox>
                                    <el-checkbox label="松弛"></el-checkbox>
                                    <el-checkbox label="唇角下垂"></el-checkbox>
                                    <el-checkbox label="唇纹"></el-checkbox>
                                    <el-checkbox label="唇色青"></el-checkbox>
                                    <el-checkbox label="唇色苍白"></el-checkbox>
                                    <el-checkbox label="漂唇"></el-checkbox>
                                    <el-checkbox label="唇色红润"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="skinTesting.bzother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>颈部</el-divider>
                                <el-checkbox-group v-model="skinTesting.jbarray">
                                    <el-checkbox label="松弛"></el-checkbox>
                                    <el-checkbox label="颈纹"></el-checkbox>
                                    <el-checkbox label="条"></el-checkbox>
                                    <el-checkbox label="紧实光洁"></el-checkbox>
                                    <el-checkbox label="疣"></el-checkbox>
                                    <el-checkbox label="颈纹过多"></el-checkbox>
                                    <el-checkbox label="肤色不均匀"></el-checkbox>
                                    <el-checkbox label="松弛下垂"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="skinTesting.jbother"></el-input>
                            </el-form-item>
                            <el-form-item label="过敏史" v-show="false">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="skinTesting.gms"></el-input>
                            </el-form-item>
                            <el-form-item label="顾客比较在意的面部问题" v-show="false">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="skinTesting.mbhlyq"></el-input>
                            </el-form-item>
                        <!--</el-form>
                        <van-tabbar>
                            <van-button type="primary" color="#1989fa" size="large" @click="saveSkinTesting">保存</van-button>
                        </van-tabbar>

                        <el-form label-position="top" :model="health" class="pfzk">-->
                            <el-divider>身体状况</el-divider>
                            <el-form-item v-show="false">
                                <el-divider>身体状况</el-divider>
                                <el-divider v-show="false">头部</el-divider>
                                <el-checkbox-group v-model="health.tbarray" v-show="false">
                                    <el-checkbox label="掉发"></el-checkbox>
                                    <el-checkbox label="眩晕"></el-checkbox>
                                    <el-checkbox label="头痛"></el-checkbox>
                                    <el-checkbox label="记忆力减退"></el-checkbox>
                                    <el-checkbox label="耳鸣"></el-checkbox>
                                    <el-checkbox label="面部色斑"></el-checkbox>
                                    <el-checkbox label="面色萎黄少泽"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.tbother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>胸部</el-divider>
                                <el-checkbox-group v-model="health.xbarray">
                                    <el-checkbox label="胸闷"></el-checkbox>
                                    <el-checkbox label="胸痛"></el-checkbox>
                                    <el-checkbox label="心悸"></el-checkbox>
                                    <el-checkbox label="肋痛"></el-checkbox>
                                    <el-checkbox label="咳嗽"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.xbother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>腹部</el-divider>
                                <el-checkbox-group v-model="health.fbarray">
                                    <el-checkbox label="胃痛"></el-checkbox>
                                    <el-checkbox label="腹胀"></el-checkbox>
                                    <el-checkbox label="胃寒"></el-checkbox>
                                    <el-checkbox label="腰酸胀痛"></el-checkbox>
                                    <el-checkbox label="嗳气"></el-checkbox>
                                    <el-checkbox label="尿急"></el-checkbox>
                                    <el-checkbox label="尿频"></el-checkbox>
                                </el-checkbox-group>
                                <el-row>
                                    <el-col :span="12">
                                        便秘<el-input type="number" v-model="health.bm" size="mini" style="width: 50px;"></el-input>天1次
                                    </el-col>
                                    <el-col :span="12">
                                        便希1天<el-input type="number" v-model="health.bx" size="mini" style="width: 50px;"></el-input>次
                                </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.fbother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>全身</el-divider>
                                <el-checkbox-group v-model="health.qsarray">
                                    <el-checkbox label="身体乏力"></el-checkbox>
                                    <el-checkbox label="肢面浮肿"></el-checkbox>
                                    <el-checkbox label="怕冷"></el-checkbox>
                                    <el-checkbox label="怕热"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.qsother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>泌尿系统</el-divider>
                                <el-checkbox-group v-model="health.mnxtarray">
                                    <el-checkbox label="尿频"></el-checkbox>
                                    <el-checkbox label="尿急"></el-checkbox>
                                    <el-checkbox label="尿血"></el-checkbox>
                                    <el-checkbox label="尿痛"></el-checkbox>
                                    <el-checkbox label="尿分叉"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.mnxtother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>妇科</el-divider>
                                <el-checkbox-group v-model="health.fkarray">
                                    <el-checkbox label="白带异常"></el-checkbox>
                                    <el-checkbox label="月经紊乱"></el-checkbox>
                                    <el-checkbox label="痛经"></el-checkbox>
                                    <el-checkbox label="绝经"></el-checkbox>
                                    <el-checkbox label="子宫肌瘤"></el-checkbox>
                                    <el-checkbox label="乳腺增生"></el-checkbox>
                                    <el-checkbox label="卵巢囊肿"></el-checkbox>
                                    <el-checkbox label="输卵管堵塞"></el-checkbox>
                                    <el-checkbox label="月经不调"></el-checkbox>
                                    <el-checkbox label="产后恢复"></el-checkbox>
                                    <el-checkbox label="慢性妇科炎症"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.fkother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>其他症状</el-divider>
                                <el-checkbox-group v-model="health.qtzzarray">
                                    <el-checkbox label="饮食减少"></el-checkbox>
                                    <el-checkbox label="情绪低落"></el-checkbox>
                                    <el-checkbox label="烦躁易怒"></el-checkbox>
                                    <el-checkbox label="发热"></el-checkbox>
                                    <el-checkbox label="呼吸困难"></el-checkbox>
                                    <el-checkbox label="关节僵硬"></el-checkbox>
                                    <el-checkbox label="多汗"></el-checkbox>
                                    <el-checkbox label="自汗"></el-checkbox>
                                    <el-checkbox label="盗汗"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.qtzzother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>骨关节类等疾病</el-divider>
                                <el-checkbox-group v-model="health.ggjlarray">
                                    <el-checkbox label="颈椎病"></el-checkbox>
                                    <el-checkbox label="肩周炎"></el-checkbox>
                                    <el-checkbox label="腰间盘突出"></el-checkbox>
                                    <el-checkbox label="腰肌劳损"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.ggjlother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>内科</el-divider>
                                <el-checkbox-group v-model="health.nkarray">
                                    <el-checkbox label="风湿"></el-checkbox>
                                    <el-checkbox label="类风湿"></el-checkbox>
                                    <el-checkbox label="糖尿病"></el-checkbox>
                                    <el-checkbox label="高血糖"></el-checkbox>
                                    <el-checkbox label="高血压"></el-checkbox>
                                    <el-checkbox label="高血脂"></el-checkbox>
                                    <el-checkbox label="脂肪肝"></el-checkbox>
                                    <el-checkbox label="心脏病"></el-checkbox>
                                    <el-checkbox label="胃病"></el-checkbox>
                                    <el-checkbox label="中风后遗症"></el-checkbox>
                                    <el-checkbox label="慢性疲劳症"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.nkother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>男科</el-divider>
                                <el-checkbox-group v-model="health.nkjbarray">
                                    <el-checkbox label="前列腺疾病"></el-checkbox>
                                    <el-checkbox label="早泄"></el-checkbox>
                                    <el-checkbox label="性功能障碍"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.nkjbother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>妇科</el-divider>
                                <el-checkbox-group v-model="health.fkjbarray">
                                    <el-checkbox label="子宫肌瘤"></el-checkbox>
                                    <el-checkbox label="乳腺增生"></el-checkbox>
                                    <el-checkbox label="卵巢囊肿"></el-checkbox>
                                    <el-checkbox label="输卵管堵塞"></el-checkbox>
                                    <el-checkbox label="月经不调"></el-checkbox>
                                    <el-checkbox label="产后恢复"></el-checkbox>
                                    <el-checkbox label="慢性妇科炎症"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.fkjbother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>儿科</el-divider>
                                <el-checkbox-group v-model="health.ekjbarray">
                                    <el-checkbox label="厌食"></el-checkbox>
                                    <el-checkbox label="身瘦"></el-checkbox>
                                    <el-checkbox label="便秘"></el-checkbox>
                                    <el-checkbox label="遗尿"></el-checkbox>
                                    <el-checkbox label="个子偏矮"></el-checkbox>
                                    <el-checkbox label="注意力不集中"></el-checkbox>
                                    <el-checkbox label="孤僻不合群"></el-checkbox>
                                    <el-checkbox label="假性近视"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.ekjbother"></el-input>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-divider>睡眠情况</el-divider>
                                <el-checkbox-group v-model="health.smqkarray">
                                    <el-checkbox label="良好"></el-checkbox>
                                    <el-checkbox label="失眠"></el-checkbox>
                                    <el-checkbox label="多梦"></el-checkbox>
                                    <el-checkbox label="易惊醒"></el-checkbox>
                                    <el-checkbox label="不易入睡"></el-checkbox>
                                    <el-checkbox label="醒后疲劳"></el-checkbox>
                                    <el-checkbox label="盗汗"></el-checkbox>
                                    <el-checkbox label="嗜睡"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item v-show="false">
                                <el-input type="textarea" placeholder="请描述以上问题详情" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.smqkother"></el-input>
                            </el-form-item>
                            <el-form-item label="其他疾病" v-show="false">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="health.qtjb"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" placeholder="请描述顾客在乎的身体问题" v-model="health.stxq"></el-input>
                            </el-form-item>
                        </el-form>
                        <van-tabbar>
                            <van-button type="primary" color="#1989fa" size="large" @click="saveSt">保存</van-button>
                        </van-tabbar>
                    </el-tab-pane>
                <el-tab-pane label="销售">
                <el-descriptions class="margin-top" :column="2" size="mini" direction="vertical"  border>
                    <el-descriptions-item>
                        <template slot="label">
                          同店的朋友
                        </template>
                        <el-input placeholder="请输入内容" size="mini" v-model="beautySale.friendname"></el-input>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                          卡号
                        </template>
                        <el-input v-model="beautySale.friendcardnumber" placeholder="请输入内容" size="mini" @change="getCardInfoByCardNumberNormal"></el-input>
                    </el-descriptions-item>
                </el-descriptions>

                <el-tabs v-model="activexs" stretch @tab-click="activexsHandleClick">
                    <!--<el-tab-pane label="销售习惯" name="first" class="pfzk" style="display: none;" v-show="false">
                        <el-descriptions :column="1" border class="xsxj">
                            <el-descriptions-item label="年消费能力">
                                <el-radio-group v-model="beautySale.xfnl">
                                    <el-radio :label="1">(0-1)</el-radio>
                                    <el-radio :label="2">(1-3)</el-radio>
                                    <el-radio :label="3">(3-5)</el-radio>
                                    <el-radio :label="4">(5-10)</el-radio>
                                    <el-radio :label="5">(10-20)</el-radio>
                                    <el-radio :label="6">(20-30)</el-radio>
                                    <el-radio :label="7">(30-50)</el-radio>
                                    <el-radio :label="8">(50以上)</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="消费自主权">
                                <el-radio-group v-model="beautySale.xfzzq">
                                    <el-radio :label="1">自主</el-radio>
                                    <el-radio :label="2">不自主</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="消费习惯">
                                <el-radio-group v-model="beautySale.xfxg">
                                    <el-radio :label="1">爽快</el-radio>
                                    <el-radio :label="2">纠结</el-radio>
                                    <el-radio :label="3">贪小</el-radio>
                                    <el-radio :label="4">分期</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="消费性格">
                                <el-radio-group v-model="beautySale.zxfxg">
                                    <el-radio :label="3">冲动</el-radio>
                                    <el-radio :label="6">理智</el-radio>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item label="在什么情况下比较容易销售">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="beautySale.qk"></el-input>
                            </el-descriptions-item>-->
                            <!--<el-descriptions-item label="有无欠款">
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="beautySale.qk"></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item label="单次最高消费金额">
                                <div v-for="(item,index) in maxCardTransactionHistory" :key="index">
                                    {{item.accountdate}}{{item.projectname}}:{{item.amount}}
                                </div>

                            </el-descriptions-item>
                            <el-descriptions-item label="在米兰合计消费">
                                {{sumAmount}}
                            </el-descriptions-item>
                            <el-descriptions-item label="最近一次消费">
                                <div v-for="(item,index) in lately" :key="index">
                                    {{item.accountdate}}{{item.projectname}}:{{item.amount}}
                                </div>
                            </el-descriptions-item>

                        </el-descriptions>

                        <el-descriptions :column="1" border direction="vertical" class="xsxj">
                            <el-descriptions-item label="周庆消费历史（时间，项目，金额）">
                                <el-tabs v-model="activeznq">
                                    <el-tab-pane :label="item.month+'年'" :name="item.month" :key="index" v-for="(item,index) in znqData">
                                        <div v-for="(val,idx) in item.array" :key="idx">
                                            {{val.accountdate}}{{val.projectname}}:{{val.amount}}
                                        </div>
                                    </el-tab-pane>
                                </el-tabs>
                            </el-descriptions-item>-->
                        <!--</el-descriptions>
                        <van-tabbar>
                            <van-button type="primary" color="#1989fa" size="large" @click="saveBeautySale">保存</van-button>
                        </van-tabbar>
                    </el-tab-pane>-->
                    <el-tab-pane label="销售日志" name="second">
                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getCardTransactionhistoryByCardIdPage">
                                <div v-for="(item,key) in beautySaleLogs" :key="key" style="margin-bottom: 20px;">
                                    <el-descriptions class="margin-top" direction="vertical"  :column="1" border  >
                                        <el-descriptions-item>
                                            <template slot="label">
                                                {{item.accountdate}}
                                                <span v-for="(val,idx) in item.cardTransactionHistories" :key="idx">
                                                    {{val.projectname}}
                                                </span>
                                               <van-uploader v-model="item.fileList" :afterRead="(file)=>afterRead(file,item)" v-if="item.fileList==null || item.fileList.length<1">
                                                 <el-button type="primary"  size="mini" icon="el-icon-camera-solid" >拍照</el-button>
                                               </van-uploader>
                                               <van-uploader v-model="item.fileList" accept="image/png,image/jpeg" @delete="(event,index)=>deleteImg(event,index,item)" :afterRead="(file)=>afterRead(file,item)" v-if="item.fileList!=null && item.fileList.length>0"/>
                                            </template>
                                                <el-form size="mini" @submit.native.prevent>
                                                    <div v-for="(val,idx) in item.projectPoints">
                                                        <el-form-item :label="val.projectname+'为什么购买'" :key="idx">
                                                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="val.whybuy"></el-input>
                                                        </el-form-item>
                                                        <el-form-item :label="val.projectname+'操作细节'">
                                                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="val.details"></el-input>
                                                        </el-form-item>
                                                    </div>
                                                </el-form>
                                        </el-descriptions-item>
                                        <el-descriptions-item>
                                            <template slot="label">
                                                具体的方案，赠送及聊天
                                            </template>
                                            <el-input type="textarea" v-model="item.beautySaleLog.programme" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                        </el-descriptions-item>
                                        <!--<el-descriptions-item >
                                          <template slot="label">
                                            照片
                                          </template>

                                        </el-descriptions-item>-->
                                        <!--<el-descriptions-item>
                                            <template slot="label">
                                                为什么购买
                                            </template>
                                            <el-input type="textarea" v-model="item.beautySaleLog.connected" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                        </el-descriptions-item>
                                        <el-descriptions-item>
                                            <template slot="label">
                                                操作注意事项
                                            </template>
                                            <el-input type="textarea" v-model="item.beautySaleLog.bedding" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                        </el-descriptions-item>-->
                                    </el-descriptions>
                                    <van-button type="primary" color="#1989fa" size="large" @click="saveBeautySaleLog(item)">保存</van-button>
                                </div>
                        </van-list>
                    </el-tab-pane>
                    <el-tab-pane label="课程注意事项" name="seconds">
                        <el-descriptions class="margin-top pfzk" :column="1" direction="vertical"  border>
                            <el-descriptions-item :label="item.projectname" v-for="(item,key) in projectPoints" :key="key">
                                <el-form size="mini" @submit.native.prevent>
                                    <el-form-item label="操作注意事项">
                                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="item.details"></el-input>
                                    </el-form-item>
                                    <el-form-item label="为什么要购买">
                                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="item.whybuy"></el-input>
                                    </el-form-item>
                                    <el-form-item style="margin-top: 5px;">
                                        <van-button type="primary" color="#1989fa" size="large" @click="saveProjectPoints(item)">保存</van-button>
                                    </el-form-item>
                                </el-form>
                            </el-descriptions-item>
                        </el-descriptions>
                        <!--<el-tabs v-model="activexf" stretch @tab-click="getBeautyCqTaskByCard()">
                            <el-tab-pane :label="item" :name="item" v-for="(item,key) in activeLabel" :key="key"></el-tab-pane>
                        </el-tabs>
                                <el-descriptions class="margin-top pfzk" :column="1" size="mini" direction="vertical"  border>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        1月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq1"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.projecttotaltype1"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini"
                                                :options="goodstotaltypes"
                                                v-model="beautyCqTasks.goodstotaltype1"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        2月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq2"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.projecttotaltype2"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype2"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        3月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq3"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.projecttotaltype3"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini"
                                                :options="goodstotaltypes" v-model="beautyCqTasks.goodstotaltype3"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        4月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq4"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.projecttotaltype4"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype4"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        5月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq5" type="number"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.projecttotaltype5"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype5"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        6月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq6" type="number"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.projecttotaltype6"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype6"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        7月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq7" type="number"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.projecttotaltype7"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype7"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        8月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq8" type="number"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.projecttotaltype8"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype8"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        9月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq9" type="number"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype9"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype9"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        10月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq10" type="number"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype10"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype10"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        11月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq11" type="number"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype11"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype11"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                        12月
                                        </template>
                                        <el-row>
                                            <el-col :span="12">
                                                出钱:<el-input style="width: 120px;" placeholder="请输入内容" size="mini" v-model="beautyCqTasks.taskcq12" type="number"></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                项目:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype12"
                                                    :options="projecttotaltypes"
                                                    :props="props"
                                                    clearable>
                                                </el-cascader>
                                            </el-col>
                                        </el-row>
                                        <el-row style="margin-top: 10px;">
                                            <el-col :span="24">
                                                产品:<el-cascader collapse-tags style="width: 120px;" size="mini" v-model="beautyCqTasks.goodstotaltype12"
                                                :options="goodstotaltypes"
                                                :props="props"
                                                clearable>
                                            </el-cascader>
                                            </el-col>
                                        </el-row>
                                    </el-descriptions-item>
                                </el-descriptions>
                                <van-tabbar>
                                    <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyCqTask">保存</van-button>
                                </van-tabbar>-->
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="服务">
                <el-tabs v-model="activefw" stretch @tab-click="handleClickfw">
                    <el-tab-pane label="服务注意" name="first">
                        <el-form class="pfzk" label-position="top" @submit.native.prevent>
                            <!--<el-form-item label="是否接受回访">
                                <el-radio-group v-model="beautyServer.returnVisit">
                                    <el-radio :label="1">接受</el-radio>
                                    <el-radio :label="2">不接受</el-radio>
                                  </el-radio-group>
                            </el-form-item>
                            <el-form-item label="当下客户的满意度">
                                <el-radio-group v-model="beautyServer.grade">
                                    <el-radio :label="1">一般</el-radio>
                                    <el-radio :label="2">满意</el-radio>
                                    <el-radio :label="3">不满意</el-radio>
                                    <el-radio :label="4">很满意</el-radio>
                                  </el-radio-group>
                            </el-form-item>-->
                            <el-form-item label="目前有什么不满意的状态">
                                <el-input type="textarea" v-model="beautyServer.dissatisfied" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <el-form-item label="喜欢喝什么饮料">
                                <el-input type="textarea" v-model="beautyServer.drinks" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <el-form-item label="喜欢吃什么水果">
                                <el-input type="textarea" v-model="beautyServer.fruits" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <el-form-item label="喜欢吃什么食物">
                                <el-input type="textarea" v-model="beautyServer.food" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <el-form-item label="性格">
                                <el-input type="textarea" v-model="beautyServer.characters" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <el-form-item label="喜欢聊天的内容">
                                <el-input type="textarea" v-model="beautyServer.chat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <el-form-item label="不能聊什么">
                                <el-input type="textarea" v-model="beautyServer.nochat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <!--<el-form-item label="与客户的聊天记录">
                                <el-input type="textarea" v-model="beautyServer.chatlog" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>-->
                            <el-form-item label="客户讲的比较重要的话">
                                <el-input type="textarea" v-model="beautyServer.importantchat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>
                            <!--<el-form-item label="客情记录送什么时间送过什么">
                                <el-input type="textarea" v-model="beautyServer.givelog" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                            </el-form-item>-->
                        </el-form>
                        <van-tabbar>
                            <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyServer">保存</van-button>
                        </van-tabbar>
                    </el-tab-pane>
                    <el-tab-pane label="送礼记录" name="second">
                        <div style="text-align: center;margin-bottom: 10px;">
                            <el-button type="primary" size="mini" @click="addGiveRecord()">新增</el-button>
                        </div>
                        <el-card class="box-card myboxcard" v-for="(item,key) in giveRecords" :key="key"  style="margin-bottom: 10px;">
                            <div slot="header" class="clearfix">
                                <span style="font-size: 14px;">日期</span>
                                <el-date-picker value-format="yyyy-MM-dd" size="mini" v-model="item.accountdate"
                                 name="birthday" type="date" placeholder="选择日期" style="width: 160px;">
                                </el-date-picker>
                                <el-button type="primary" size="mini" @click="saveGiveRecord(item)">保存</el-button>
                            </div>
                            <span style="font-size: 14px;">赠送明细：</span>
                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 100}" v-model="item.record"></el-input>
                        </el-card>
                    </el-tab-pane>
                </el-tabs>

            </el-tab-pane>
            <el-tab-pane label="消耗">
                <!--<el-tabs v-model="activexh" stretch @tab-click="xhhandleClick">
                    <el-tab-pane label="消耗计划" name="first">
                        <el-tabs v-model="activexhjh" @tab-click="queryBeautyXfTask()">
                            <el-tab-pane :label="item" :name="item" v-for="(item,key) in activeLabel" :key="key">

                            </el-tab-pane>
                        </el-tabs>
                        <el-table v-loading="queryLoadBtton"  size="mini" :data="beautyXfTasks" highlight-current-row class="pfzk">
                            <el-table-column label="疗程名称"  align="center" prop="coursename"  width="100" fixed></el-table-column>
                            <el-table-column label="次数"  align="center" prop="curnumber"  width="60" fixed></el-table-column>
                            <el-table-column label="01"  align="center" prop="curnumber">
                                <el-table-column label="目标"  align="center" prop="tasknumber1"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber1" v-if="scope.row.tasknumber1<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber1}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="02"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber2"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber2" v-if="scope.row.tasknumber2<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber2}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="03"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber3"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber3" v-if="scope.row.tasknumber3<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber3}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="04"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber4"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber4" v-if="scope.row.tasknumber4<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber4}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="05"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber5"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%"  @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber5" v-if="scope.row.tasknumber5<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber5}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="06"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber6"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber6" v-if="scope.row.tasknumber6<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber6}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="07"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber7"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber7" v-if="scope.row.tasknumber7<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber7}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="08"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber8"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber8" v-if="scope.row.tasknumber8<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber8}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="09"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber9"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber9" v-if="scope.row.tasknumber9<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber9}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="10"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber10"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber10" v-if="scope.row.tasknumber10<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber10}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="11"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber11"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber11" v-if="scope.row.tasknumber11<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber11}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="12"  align="center" prop="curnumber"  width="100">
                                <el-table-column label="目标"  align="center" prop="tasknumber12"  width="60">
                                    <template slot-scope="scope">
                                        <el-input style="text-align: left;width: 100%" @focus="getfocus($event)" type="number"
                                                         :controls="false" size="mini" v-model="scope.row.tasknumber12" v-if="scope.row.tasknumber12<1"></el-input>
                                        <span v-else>{{scope.row.tasknumber12}}</span>
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                        <van-tabbar>
                            <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyXfTask">保存</van-button>
                        </van-tabbar>
                    </el-tab-pane>
                    <el-tab-pane label="消费日志" name="second">-->
                        <van-list v-model="loadinglog" :finished="finishedlog" finished-text="没有更多了" @load="getCardtransactionhistoryByCash">
                            <el-card class="box-card mycard" v-for="(item,key) in beautyXfLog" :key="key" style="margin-bottom: 10px;">
                                <div slot="header" style="background-color: rgb(238, 241, 246)" >
                                    {{$moment(item.accountdate).format('YYYY-MM-DD')}}
                                  <div v-for="(val,index) in item.cardTransactionHistories" :key="index">
                                      {{val.projectname}}
                                  </div>
                                </div>
                                <el-form label-position="top" size="mini" @submit.native.prevent>
                                    <!--<el-form-item label="当日消耗目标">
                                        {{item.beautyXfLog.xhtarget}}
                                    </el-form-item>-->
                                    <!--<el-form-item label="提升满意度当天做了什么(讲米兰好，效果呈现，不满意处理)">
                                        <el-input type="textarea" v-model="item.beautyXfLog.oparation" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                    </el-form-item>-->
                                    <el-form-item label="服务聊天内容">
                                        <el-input type="textarea" v-model="item.beautyXfLog.chat" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                    </el-form-item>
                                    <!--<el-form-item label="消耗时铺垫了什么项目(进度)">
                                        <el-input type="textarea" v-model="item.beautyXfLog.xhtarget" :autosize="{ minRows: 2, maxRows: 100}"></el-input>
                                    </el-form-item>-->
                                    <div style="margin-top: 5px;">
                                        <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyXfLog(item,0)" style="width: 60%;">保存</van-button>
                                        <van-button type="primary" color="#1989fa" size="large" @click="saveBeautyXfLog(item,1)" style="width: 30%;float: right;">保存预约</van-button>
                                    </div>
                                </el-form>
                                <!--<el-form @submit.native.prevent>
                                    <el-form-item label="下次到店日期">
                                        <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 130px"
                                            v-model="item.beautyXfLog.nextdate" name="birthday"
                                            type="date"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>

                                </el-form>-->
                            </el-card>
                        </van-list>
                    <!--</el-tab-pane>
                </el-tabs>-->
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                projectPoints:[],
                giveRecords:[],
                giveRecord:{
                    storeid:"",
                    cardid:"",
                    accountdate:"",
                    record:"",
                },
                activefw:"first",
                membersources:[],
                beautyXfLog:[],
                finishedlog:false,
                loadinglog:false,
                beautyXfTasks:[],
                activexh:"first",
                isbeautyserver:false,
                beautyServer:{
                    storeid:"",
                    cardid:"",
                    memberid:"",
                    returnVisit:0,
                    grade:0,
                    dissatisfied:"",
                    drinks:"",
                    fruits:"",
                    food:"",
                    characters:"",
                    chat:"",
                    nochat:"",
                    chatlog:"",
                    importantchat:"",
                    givelog:"",
                },
                loading:false,
                activexhjh:new Date().getFullYear(),
                activexf:new Date().getFullYear(),
                activeLabel:[new Date().getFullYear(),new Date().getFullYear()+1],
                beautyCqTasks:{},
                props: { multiple: true },
                projecttotaltypes:[],
                activeznq:"1",
                beautySale:{
                    storeid:"",
                    cardid:"",
                    memberid:"",
                    friendname:"",
                    friendcardnumber:"",
                    xfnl:0,
                    xfzzq:0,
                    xfxg:0,
                    zxfxg:0,
                    qk:0,
                },
                activexs:"second",
                isloadst:false,
                active:0,
                activeName:"first",
                skinTesting:{
                    storeid:"",
                    cardid:"",
                    memberid:"",
                    skinzkarray:[],
                    etarray:[],
                    ybarray:[],
                    mjarray:[],
                    bzarray:[],
                    jbarray:[],
                    gms:"",
                    mbhlyq:"",
                    skinzkother:"",
                    etother:"",
                    ybother:"",
                    mjother:"",
                    bzother:"",
                    jbother:"",
                },
                health:{
                    storeid:"",
                    cardid:"",
                    memberid:"",
                    tbarray:[],
                    xbarray:[],
                    fbarray:[],
                    qsarray:[],
                    mnxtarray:[],
                    fkarray:[],
                    qtzzarray:[],
                    ggjlarray:[],
                    nkarray:[],
                    nkjbarray:[],
                    fkjbarray:[],
                    ekjbarray:[],
                    smqkarray:[],
                    qtjb:"",
                    stxq:"",
                    bm:0,
                    bx:0,
                    tbother:"",
                    xbother:"",
                    fbother:"",
                    qsother:"",
                    mnxtother:"",
                    fkother:"",
                    qtzzother:"",
                    ggjlother:"",
                    nkother:"",
                    nkjbother:"",
                    fkjbother:"",
                    ekjbother:"",
                    smqkother:"",
                },
                cardInfoVo:{},
                memberInfo:{},
                cardid:"",
                cardnumber:"",
                storeid:localStorage.getItem("storeid"),
                beautydate:"",
                mldate:"",
                cardAccounts:[],
                cardCourses:[],
                projectTypes:[],
                projectExperienceTypes:[],
                memberid:"",
                maxCardTransactionHistory:[],
                sumAmount:0,
                lately:[],
                isloadss:false,
                znqData:[],
                beautySaleLogs:[],
                curPage:0,
                isloadxsxj:false,
                finished:false,
                goodstotaltypes:[],
                isloadxsjh:false,
                curPageNo:0,
                notExperiences:[],
                membername:"",
                cardtypeid:"",
                sex:0,
                beautyHeader:[],
                orderInfo:{},
                beautySaleLogVo:{},
            }
        },
        created: function () {
            this.cardid=this.$route.query.cardid;
            this.cardnumber=this.$route.query.cardnumber;
            this.memberid=this.$route.query.memberid;
            this.membername=this.$route.query.membername;
            this.cardtypeid=this.$route.query.cardtypeid;
            this.sex=this.$route.query.sex;
            this.getCardInfoByCardNumberUnsold();
            this.getBeautyMinDate();
            this.getMinDate();
            this.getCardAccountByCardId();
            this.getCardCourseByCardId();
            this.getBeautyXfProjectTypeByCardId();
            this.getBeautyXfProjectTypeExperienceByCardId();
            this.getMemberInfoById();
            this.getConstantInfoByType();
            this.getConstantInfoByGoodsType();
            this.getConstantInfo();
            this.getNotExperience();
            this.getBeautyHeaderStaffByCardId();
            this.getNewOrderByCardId();
            this.getNewCardTransaction();
        },
        methods:{
          deleteBeautySaleLogImageById(id){
            console.log(id);
            this.$post("beautymanager/deleteBeautySaleLogImageById",{id:id}).then(res=>{
                if(res.sucess){
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                }
                else{
                  this.$message({
                    message: res.message,
                    type: 'error'
                  });
                }
            });
          },
          deleteImg(event,index,item){
            console.log(event);
            let path=event.url.replace(this.baseImageUrl,"");
            this.$post("file/deleteFile",{path:path}).then(res=>{
              if(res.sucess){
                //item.fileList.splice(index.index,1);
                this.deleteBeautySaleLogImageById(event.id);
              }
              else{
                this.$message({
                  message: res.message,
                  type: 'error'
                });
              }
            });
          },
          addBeautySaleLogImage(item,url){
              let beautySaleLogImage=new Object();
              beautySaleLogImage.storeid=item.cardTransactionHistories[0].storeid;
              beautySaleLogImage.cardid=item.cardTransactionHistories[0].cardid;
              beautySaleLogImage.accountdate=item.cardTransactionHistories[0].accountdate;
              beautySaleLogImage.imageurl=url;
              this.$postw("beautymanager/addBeautySaleLogImage",beautySaleLogImage).then(res=>{
                if(res.sucess){
                  let obj=new Object();
                  obj.deletable=true;
                  obj.url=this.baseImageUrl+url;
                  obj.id=res.object.id;
                  if(!item.fileList){
                    item.fileList=[];
                  }
                  //item.fileList.push(obj);
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                }
                else{
                  this.$message.error(res.message);
                }
              });
            },
            afterRead(event,item){
              console.log(event);
              let formData = new FormData()
              formData.append('file', event.file);
              this.$upload("file/filePathUpload?path=beautysalelog",formData).then(res=>{
                if(res.sucess){
                  this.addBeautySaleLogImage(item,res.object);
                }
                else{
                  this.$message({
                    message: res.message,
                    type: 'error'
                  });
                }
              });
            },
            getNewCardTransaction(){
                this.$post("beautymanager/getNewCardTransaction",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        if(res.object){
                            this.beautySaleLogVo=res.object;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getNewOrderByCardId(){
                this.$post("beautymanager/getNewOrderByCardId",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        if(res.object){
                            this.orderInfo=res.object;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyHeaderStaffByCardId(){
                this.$post("beautymanager/getBeautyHeaderStaffByCardId",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.beautyHeader=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveProjectPoints(item){
                item.storeid=this.storeid;
                item.cardid=this.cardid;
                item.memberid=this.memberid;
                this.$postw("beautymanager/saveProjectPoints",item).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getProjectPointsById(){
                this.$post("beautymanager/getProjectPointsById",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.projectPoints=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveSt(){
                this.saveHealth();
                this.saveSkinTesting();
            },
            getNotExperience(){
                this.$post("beautymanager/getNotExperience",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.notExperiences=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveWhyBuy(obj){
                let whyadd=new Object();
                whyadd.storeid=this.storeid;
                whyadd.cardid=this.cardid;
                whyadd.uuid=obj.whyAdd.uuid;
                whyadd.projecttotaltype1=obj.projecttotaltype1;
                whyadd.projecttotaltype2=obj.projecttotaltype2;
                whyadd.remarks=obj.whyAdd.remarks;
                this.$postw("beautymanager/saveWhyBuy",whyadd).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        obj.whyAdd=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveWhyAdd(obj){
                let whyadd=new Object();
                whyadd.storeid=this.storeid;
                whyadd.cardid=this.cardid;
                whyadd.uuid=obj.whyAdd.uuid;
                whyadd.projecttotaltype1=obj.projecttotaltype1;
                whyadd.projecttotaltype2=obj.projecttotaltype2;
                whyadd.remarks=obj.whyAdd.remarks;
                this.$postw("beautymanager/saveWhyAdd",whyadd).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        obj.whyAdd=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            addGiveRecord(){
                this.giveRecords.unshift(this.$copy(this.giveRecord));
            },
            handleClickfw(){
                if(this.activefw=="second"){
                    this.getGiveRecordByStore();
                }
            },
            saveGiveRecord(item){
                if(!item.accountdate){
                    this.$message.error("请选择日期");
                    return;
                }
                if(!item.record){
                    this.$message.error("请输入赠送明细");
                    return;
                }
                item.storeid=this.storeid;
                item.cardid=this.cardid;
                this.$postw("beautymanager/saveGiveRecord",item).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getGiveRecordByStore(){
                this.$post("beautymanager/getGiveRecordByStore",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            this.giveRecords=obj;
                        }
                        else{
                            this.giveRecords.push(this.$copy(this.giveRecord));
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getConstantInfo(){
                this.$post("basis/getConstantInfo",{storeid:this.storeid,constanttype:"GKLY",status:0,guid:"",lv:2}).then(res=>{
                    if(res.sucess){
                        this.membersources=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveBeautyXfLog(item,type){
                if(!item.beautyXfLog.chat){
                    this.$message.error("请输入聊天类容");
                    return;
                }
                let beautyXfLog=new Object();
                beautyXfLog.storeid=this.storeid;
                beautyXfLog.cardid=this.cardid;
                beautyXfLog.memberid=this.memberid;
                beautyXfLog.accountdate=item.accountdate;
                beautyXfLog.oparation=item.beautyXfLog.oparation;
                beautyXfLog.xhtarget=item.beautyXfLog.xhtarget;
                beautyXfLog.chat=item.beautyXfLog.chat;
                beautyXfLog.nextdate=item.beautyXfLog.nextdate;
                let projectname="";
                for(let val of item.cardTransactionHistories){
                    if(projectname!=""){
                        projectname=projectname+","+val.projectname;
                    }
                    else{
                        projectname=val.projectname;
                    }
                }
                beautyXfLog.projectname=projectname;
                this.$postw("beautymanager/saveBeautyXfLog",beautyXfLog).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        if(type==1){
                            this.$router.push({path:"/beautyorder",query:{
                                cardid:this.cardid,
                                cardnumber:this.cardnumber,
                                memberid:this.memberid,
                                membername:this.membername,
                                memberphone:this.memberphone,
                                cardtypeid:this.cardtypeid,
                                sex:this.sex
                            }});
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            xhhandleClick(){
                if(this.activexh=="second"){
                    this.getCardtransactionhistoryByCash();
                }
            },
            getCardtransactionhistoryByCash(){
                this.curPageNo++;
                this.loadinglog=true;
                this.$post("beautymanager/getCardtransactionhistoryByCash",{storeid:this.storeid,cardid:this.cardid,curPage:this.curPageNo}).then(res=>{
                    this.loadinglog=false;
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.beautyXfLog.push(val);
                            }
                        }
                        else{
                            this.finishedlog=true;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveBeautyXfTask(){
                let obj=new Array();
                for(let val of this.beautyXfTasks){
                    if(val.tasknumber1>0 || val.tasknumber2>0 || val.tasknumber3>0 || val.tasknumber4>0 || val.tasknumber5>0 || val.tasknumber6>0 || val.tasknumber7>0
                    || val.tasknumber8>0 || val.tasknumber9>0 || val.tasknumber10>0 || val.tasknumber11>0 || val.tasknumber12>0){
                        obj.push(val);
                    }
                }
                if(obj==null || obj.length<1){
                    this.$message.error("请填写消费计划");
                    return;
                }
                this.$postw("cardmanager/saveBeautyXfTask?storeid="+this.storeid+"&cardid="+this.cardid+"&year="+this.activexhjh,obj).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            queryBeautyXfTask(){
                this.$post("cardmanager/getBeautyXfTaskByCard",{storeid:this.storeid,cardid:this.cardid,year:this.activexhjh}).then(res=>{
                    if(res.sucess){
                        this.beautyXfTasks = res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveBeautyServer(){
                this.beautyServer.storeid=this.storeid;
                this.beautyServer.memberid=this.memberid;
                this.beautyServer.cardid=this.cardid;
                this.$postw("beautymanager/saveBeautyServer",this.beautyServer).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyServerById(){
                this.$post("beautymanager/getBeautyServerById",{storeid:this.storeid,memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        this.beautyServer=res.object;
                        if(this.beautyServer==null){
                            this.beautyServer={};
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            beautyCqTaskValidate(cq,project,goods){
                if(cq>0 &&((project==null || project.length<1) && (goods==null || goods.length<1))){
                    return false;
                }
                return true;
            },
            saveBeautyCqTask(){
                if(this.beautyCqTasks.taskcq1<1 && this.beautyCqTasks.taskcq2<1 && this.beautyCqTasks.taskcq3<1 && this.beautyCqTasks.taskcq4<1
                && this.beautyCqTasks.taskcq5<1 && this.beautyCqTasks.taskcq6<1 && this.beautyCqTasks.taskcq7<1 && this.beautyCqTasks.taskcq8<1
                && this.beautyCqTasks.taskcq9<1 && this.beautyCqTasks.taskcq10<1 && this.beautyCqTasks.taskcq11<1 && this.beautyCqTasks.taskcq12<1){
                    this.$message.error("请填写出钱计划");
                    return;
                }
                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq1,this.beautyCqTasks.projecttotaltype1,this.beautyCqTasks.goodstotaltype1)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq2,this.beautyCqTasks.projecttotaltype2,this.beautyCqTasks.goodstotaltype2)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq3,this.beautyCqTasks.projecttotaltype3,this.beautyCqTasks.goodstotaltype3)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq4,this.beautyCqTasks.projecttotaltype4,this.beautyCqTasks.goodstotaltype4)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq5,this.beautyCqTasks.projecttotaltype5,this.beautyCqTasks.goodstotaltype5)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq6,this.beautyCqTasks.projecttotaltype6,this.beautyCqTasks.goodstotaltype6)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq7,this.beautyCqTasks.projecttotaltype7,this.beautyCqTasks.goodstotaltype7)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }


                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq8,this.beautyCqTasks.projecttotaltype8,this.beautyCqTasks.goodstotaltype8)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq9,this.beautyCqTasks.projecttotaltype9,this.beautyCqTasks.goodstotaltype9)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq10,this.beautyCqTasks.projecttotaltype10,this.beautyCqTasks.goodstotaltype10)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq11,this.beautyCqTasks.projecttotaltype11,this.beautyCqTasks.goodstotaltype11)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTaskValidate(this.beautyCqTasks.taskcq12,this.beautyCqTasks.projecttotaltype12,this.beautyCqTasks.goodstotaltype12)==false){
                    this.$message.error("填写了出钱金额，就必须要选择项目类型或者产品类型", '提示');
                    return;
                }

                if(this.beautyCqTasks.projecttotaltype1!=null && this.beautyCqTasks.projecttotaltype1.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype1){
                        let array=this.beautyCqTasks.projecttotaltype1[i];
                        console.log(array.join(","));
                        this.beautyCqTasks.projecttotaltype1[i]="";
                        this.beautyCqTasks.projecttotaltype1[i]=array.join(",");
                    }
                }

                if(this.beautyCqTasks.goodstotaltype1!=null && this.beautyCqTasks.goodstotaltype1.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype1){
                        let array=this.beautyCqTasks.goodstotaltype1[i];
                        this.beautyCqTasks.goodstotaltype1[i]=array.join(",");
                    }
                }

                if(this.beautyCqTasks.projecttotaltype2!=null && this.beautyCqTasks.projecttotaltype2.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype2){
                        let array=this.beautyCqTasks.projecttotaltype2[i];
                        this.beautyCqTasks.projecttotaltype2[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype2!=null && this.beautyCqTasks.goodstotaltype2.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype2){
                        let array=this.beautyCqTasks.goodstotaltype2[i];
                        this.beautyCqTasks.goodstotaltype2[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.projecttotaltype3!=null && this.beautyCqTasks.projecttotaltype3.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype3){
                        let array=this.beautyCqTasks.projecttotaltype3[i];
                        this.beautyCqTasks.projecttotaltype3[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype3!=null && this.beautyCqTasks.goodstotaltype3.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype3){
                        let array=this.beautyCqTasks.goodstotaltype3[i];
                        this.beautyCqTasks.goodstotaltype3[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.projecttotaltype4!=null && this.beautyCqTasks.projecttotaltype4.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype4){
                        let array=this.beautyCqTasks.projecttotaltype4[i];
                        this.beautyCqTasks.projecttotaltype4[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype4!=null && this.beautyCqTasks.goodstotaltype4.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype4){
                        let array=this.beautyCqTasks.goodstotaltype4[i];
                        this.beautyCqTasks.goodstotaltype4[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.projecttotaltype5!=null && this.beautyCqTasks.projecttotaltype5.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype5){
                        let array=this.beautyCqTasks.projecttotaltype5[i];
                        this.beautyCqTasks.projecttotaltype5[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype5!=null && this.beautyCqTasks.goodstotaltype5.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype5){
                        let array=this.beautyCqTasks.goodstotaltype5[i];
                        this.beautyCqTasks.goodstotaltype5[i]=array.join(",");
                    }
                }

                if(this.beautyCqTasks.projecttotaltype6!=null && this.beautyCqTasks.projecttotaltype6.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype6){
                        let array=this.beautyCqTasks.projecttotaltype6[i];
                        this.beautyCqTasks.projecttotaltype6[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype6!=null && this.beautyCqTasks.goodstotaltype6.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype6){
                        let array=this.beautyCqTasks.goodstotaltype6[i];
                        this.beautyCqTasks.goodstotaltype6[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.projecttotaltype7!=null && this.beautyCqTasks.projecttotaltype7.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype7){
                        let array=this.beautyCqTasks.projecttotaltype7[i];
                        this.beautyCqTasks.projecttotaltype7[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype7!=null && this.beautyCqTasks.goodstotaltype7.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype7){
                        let array=this.beautyCqTasks.goodstotaltype7[i];
                        this.beautyCqTasks.goodstotaltype7[i]=array.join(",");
                    }
                }

                if(this.beautyCqTasks.projecttotaltype8!=null && this.beautyCqTasks.projecttotaltype8.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype8){
                        let array=this.beautyCqTasks.projecttotaltype8[i];
                        this.beautyCqTasks.projecttotaltype8[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype8!=null && this.beautyCqTasks.goodstotaltype8.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype8){
                        let array=this.beautyCqTasks.goodstotaltype8[i];
                        this.beautyCqTasks.goodstotaltype8[i]=array.join(",");
                    }
                }

                if(this.beautyCqTasks.projecttotaltype9!=null && this.beautyCqTasks.projecttotaltype9.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype9){
                        let array=this.beautyCqTasks.projecttotaltype9[i];
                        this.beautyCqTasks.projecttotaltype9[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype9!=null && this.beautyCqTasks.goodstotaltype9.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype9){
                        let array=this.beautyCqTasks.goodstotaltype9[i];
                        this.beautyCqTasks.goodstotaltype9[i]=array.join(",");
                    }
                }

                if(this.beautyCqTasks.projecttotaltype10!=null && this.beautyCqTasks.projecttotaltype10.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype10){
                        let array=this.beautyCqTasks.projecttotaltype10[i];
                        this.beautyCqTasks.projecttotaltype10[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype10!=null && this.beautyCqTasks.goodstotaltype10.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype10){
                        let array=this.beautyCqTasks.goodstotaltype10[i];
                        this.beautyCqTasks.goodstotaltype10[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.projecttotaltype11!=null && this.beautyCqTasks.projecttotaltype11.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype11){
                        let array=this.beautyCqTasks.projecttotaltype11[i];
                        this.beautyCqTasks.projecttotaltype11[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype11!=null && this.beautyCqTasks.goodstotaltype11.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype11){
                        let array=this.beautyCqTasks.goodstotaltype11[i];
                        this.beautyCqTasks.goodstotaltype11[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.projecttotaltype12!=null && this.beautyCqTasks.projecttotaltype12.length>0){
                    for(let i in this.beautyCqTasks.projecttotaltype12){
                        let array=this.beautyCqTasks.projecttotaltype12[i];
                        this.beautyCqTasks.projecttotaltype12[i]=array.join(",");
                    }
                }


                if(this.beautyCqTasks.goodstotaltype12!=null && this.beautyCqTasks.goodstotaltype12.length>0){
                    for(let i in this.beautyCqTasks.goodstotaltype12){
                        let array=this.beautyCqTasks.goodstotaltype12[i];
                        this.beautyCqTasks.goodstotaltype12[i]=array.join(",");
                    }
                }
                this.$postw("cardmanager/saveBeautyCqTask",this.beautyCqTasks).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        });
                        this.getBeautyCqTaskByCard();
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyCqTaskByCard(){
                this.$post("cardmanager/getBeautyCqTaskByCard",{storeid:this.storeid,cardid:this.cardid,year:this.activexf}).then(res=>{
                    if(res.sucess){
                        this.beautyCqTasks = res.object;
                        if(this.beautyCqTasks!=null){
                            if(this.beautyCqTasks.projecttotaltype1!=null && this.beautyCqTasks.projecttotaltype1.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype1){
                                    this.beautyCqTasks.projecttotaltype1[i]=this.beautyCqTasks.projecttotaltype1[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp1",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype1!=null && this.beautyCqTasks.goodstotaltype1.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype1){
                                    this.beautyCqTasks.goodstotaltype1[i]=this.beautyCqTasks.goodstotaltype1[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg1",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype2!=null && this.beautyCqTasks.projecttotaltype2.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype2){
                                    this.beautyCqTasks.projecttotaltype2[i]=this.beautyCqTasks.projecttotaltype2[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp2",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype2!=null && this.beautyCqTasks.goodstotaltype2.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype2){
                                    this.beautyCqTasks.goodstotaltype2[i]=this.beautyCqTasks.goodstotaltype2[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg2",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype3!=null && this.beautyCqTasks.projecttotaltype3.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype3){
                                    this.beautyCqTasks.projecttotaltype3[i]=this.beautyCqTasks.projecttotaltype3[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp3",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype3!=null && this.beautyCqTasks.goodstotaltype3.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype3){
                                    this.beautyCqTasks.goodstotaltype3[i]=this.beautyCqTasks.goodstotaltype3[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg3",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype4!=null && this.beautyCqTasks.projecttotaltype4.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype4){
                                    this.beautyCqTasks.projecttotaltype4[i]=this.beautyCqTasks.projecttotaltype4[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp4",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype4!=null && this.beautyCqTasks.goodstotaltype4.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype4){
                                    this.beautyCqTasks.goodstotaltype4[i]=this.beautyCqTasks.goodstotaltype4[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg4",true);
                            }


                            if(this.beautyCqTasks.projecttotaltype5!=null && this.beautyCqTasks.projecttotaltype5.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype5){
                                    this.beautyCqTasks.projecttotaltype5[i]=this.beautyCqTasks.projecttotaltype5[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp5",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype5!=null && this.beautyCqTasks.goodstotaltype5.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype5){
                                    this.beautyCqTasks.goodstotaltype5[i]=this.beautyCqTasks.goodstotaltype5[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg5",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype6!=null && this.beautyCqTasks.projecttotaltype6.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype6){
                                    this.beautyCqTasks.projecttotaltype6[i]=this.beautyCqTasks.projecttotaltype6[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp6",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype6!=null && this.beautyCqTasks.goodstotaltype6.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype6){
                                    this.beautyCqTasks.goodstotaltype6[i]=this.beautyCqTasks.goodstotaltype6[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg6",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype7!=null && this.beautyCqTasks.projecttotaltype7.length>0){
                                for(let i in this.beautyCqTasks.projecttotalType7){
                                    this.beautyCqTasks.projecttotaltype7[i]=this.beautyCqTasks.projecttotaltype7[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp7",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype7!=null && this.beautyCqTasks.goodstotaltype7.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype7){
                                    this.beautyCqTasks.goodstotaltype7[i]=this.beautyCqTasks.goodstotaltype7[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg7",true);
                            }


                            if(this.beautyCqTasks.projecttotaltype8!=null && this.beautyCqTasks.projecttotaltype8.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype8){
                                    this.beautyCqTasks.projecttotaltype8[i]=this.beautyCqTasks.projecttotaltype8[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp8",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype8!=null && this.beautyCqTasks.goodstotaltype8.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype8){
                                    this.beautyCqTasks.goodstotaltype8[i]=this.beautyCqTasks.goodstotaltype8[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg8",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype9!=null && this.beautyCqTasks.projecttotaltype9.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype9){
                                    this.beautyCqTasks.projecttotaltype9[i]=this.beautyCqTasks.projecttotaltype9[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp9",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype9!=null && this.beautyCqTasks.goodstotaltype9.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype9){
                                    this.beautyCqTasks.goodstotaltype9[i]=this.beautyCqTasks.goodstotaltype9[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg9",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype10!=null && this.beautyCqTasks.projecttotaltype10.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype10){
                                    this.beautyCqTasks.projecttotaltype10[i]=this.beautyCqTasks.projecttotaltype10[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp10",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype10!=null && this.beautyCqTasks.goodstotaltype10.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype10){
                                    this.beautyCqTasks.goodstotaltype10[i]=this.beautyCqTasks.goodstotaltype10[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg10",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype11!=null && this.beautyCqTasks.projecttotaltype11.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype11){
                                    this.beautyCqTasks.projecttotaltype11[i]=this.beautyCqTasks.projecttotaltype11[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp11",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype11!=null && this.beautyCqTasks.goodstotaltype11.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype11){
                                    this.beautyCqTasks.goodstotaltype11[i]=this.beautyCqTasks.goodstotaltype11[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg11",true);
                            }

                            if(this.beautyCqTasks.projecttotaltype12!=null && this.beautyCqTasks.projecttotaltype12.length>0){
                                for(let i in this.beautyCqTasks.projecttotaltype12){
                                    this.beautyCqTasks.projecttotaltype12[i]=this.beautyCqTasks.projecttotaltype12[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disp12",true);
                            }

                            if(this.beautyCqTasks.goodstotaltype12!=null && this.beautyCqTasks.goodstotaltype12.length>0){
                                for(let i in this.beautyCqTasks.goodstotaltype12){
                                    this.beautyCqTasks.goodstotaltype12[i]=this.beautyCqTasks.goodstotaltype12[i].split(",");
                                }
                                this.$set(this.beautyCqTasks,"disg12",true);
                            }
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getConstantInfoByGoodsType(){
                this.$post("basis/getConstantInfoByTypeConvertVo",{storeid:this.storeid,constanttype:"CPTJFL"}).then(res=>{
                    if(res.sucess){
                        this.goodstotaltypes=res.object;
                        if(this.goodstotaltypes==null){
                            this.goodstotaltypes=[];
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getConstantInfoByType(){
                this.$post("basis/getConstantInfoByTypeConvertVo",{storeid:this.storeid,constanttype:"XMTJFL"}).then(res=>{
                    if(res.sucess){
                        this.projecttotaltypes=res.object;
                        if(this.projecttotaltypes==null){
                            this.projecttotaltypes=[];
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveBeautySaleLog(item){
                let log=new Object();
                log.storeid=this.storeid;
                log.cardid=this.cardid;
                log.memberid=this.memberid;
                log.projectname="";
                log.accountdate=item.accountdate;
                for(let val of item.cardTransactionHistories){
                    if(log.projectname){
                        log.projectname=log.projectname+","+val.projectname;
                    }
                    else{
                        log.projectname=val.projectname;
                    }
                }
                log.why=item.beautySaleLog.why;
                log.programme=item.beautySaleLog.programme;
                log.connected=item.beautySaleLog.connected;
                log.bedding=item.beautySaleLog.bedding;
                log.uncultivated=item.beautySaleLog.uncultivated;
                let beautySaleLogVo=new Object();
                beautySaleLogVo.beautySaleLog=log;
                let projectPoints=[];
                for(let val of item.projectPoints){
                    if(val.whybuy || val.details){
                        projectPoints.push(val);
                    }
                }
                beautySaleLogVo.projectPoints=projectPoints;
                this.$postw("beautymanager/saveBeautySaleLog",beautySaleLogVo).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message:"保存成功",
                            type:"success"
                        });
                        this.curPage=0;
                        this.beautySaleLogs=[];
                        this.getCardTransactionhistoryByCardIdPage();

                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            activexsHandleClick(name){
                console.log(name);
                if(this.activexs=="second"){
                    if(this.isloadxsxj==false){
                        this.getCardTransactionhistoryByCardIdPage();
                    }
                }
                else if(this.activexs=="seconds"){
                    if(this.isloadxsjh==false){
                        this.isloadxsjh=true;
                        this.getProjectPointsById();
                    }
                }
            },
            getCardTransactionhistoryByCardIdPage(){
                this.curPage++;
                this.loading=true;
                this.$post("beautymanager/getCardTransactionhistoryByCardIdPage",{storeid:this.storeid,cardid:this.cardid,curPage:this.curPage}).then(res=>{
                    this.loading=false;
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0) {
                            for (let val of obj) {
                                if (val.fileList == null) {
                                    val.fileList = [];
                                }
                                this.beautySaleLogs.push(val);
                            }
                        }
                        else{
                            this.finished=true;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardInfoByCardNumberNormal() {
                if (this.beautySale.friendcardnumber == "") {
                    return;
                }
                this.$post("cardinfo/getCardInfoByCardNumberNormal",{storeid:this.storeid,cardnumber:this.beautySale.friendcardnumber}).then(res=>{
                    if(res.sucess){
                        this.beautySale.friendname=res.object.membername;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveBeautySale(){
                this.beautySale.storeid=this.storeid;
                this.beautySale.cardid=this.cardid;
                this.beautySale.memberid=this.memberid;
                this.$postw("beautymanager/saveBeautySale",this.beautySale).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message:"保存成功",
                            type:"success"
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautySaleById(){
                this.$post("beautymanager/getBeautySaleById",{storeid:this.storeid,memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        if(res.object==null){
                            this.beautySale={};
                        }
                        else{
                            this.beautySale=res.object;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardTransactionhistoryByCardId(){
                this.$post("beautymanager/getCardTransactionhistoryByCardId",{cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.maxCardTransactionHistory=res.object.maxAmount;
                        this.sumAmount=res.object.sumAmount;
                        this.lately=res.object.lately;
                        let obj=res.object.cardTransMap;
                        //console.log(obj.length);
                        if(obj!=null){
                            for(let index in obj){
                                console.log(index);
                                let data=new Object();
                                data.month=index;
                                data.array=obj[index];
                                this.znqData.push(data);
                            }
                            this.znqData.sort(function(a,b){
                                return b.month-a.month;
                            });

                            console.log(this.znqData);
                            this.activeznq=this.znqData[0].month;
                        }

                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveHealth(){
                let obj=new Object();
                obj.storeid=this.storeid;
                obj.cardid=this.cardid;
                obj.memberid=this.memberid;
                obj.tb="";
                obj.xb="";
                obj.fb="";
                obj.qs="";
                obj.mnxt="";
                obj.fk="";
                obj.qtzz="";
                obj.ggjl="";
                obj.nk="";
                obj.nkjb="";
                obj.fkjb="";
                obj.ekjb="";
                obj.smqk="";
                obj.qtjb=this.health.qtjb;
                obj.stxq=this.health.stxq;
                obj.bm=this.health.bm;
                obj.bx=this.health.bx;
                obj.tbother=this.health.tbother;
                obj.xbother=this.health.xbother;
                obj.fbother=this.health.fbother;
                obj.qsother=this.health.qsother;
                obj.mnxtother=this.health.mnxtother;
                obj.fkother=this.health.fkother;
                obj.qtzzother=this.health.qtzzother;
                obj.ggjlother=this.health.ggjlother;
                obj.nkother=this.health.nkother;
                obj.nkjbother=this.health.nkjbother;
                obj.fkjbother=this.health.fkjbother;
                obj.ekjbother=this.health.ekjbother;
                obj.smqkother=this.health.smqkother;
                if(this.health.tbarray!=null && this.health.tbarray.length>0){
                    obj.tb=this.health.tbarray.join(",");
                }
                if(this.health.xbarray!=null && this.health.xbarray.length>0){
                    obj.xb=this.health.xbarray.join(",");
                }
                if(this.health.fbarray!=null && this.health.fbarray.length>0){
                    obj.fb=this.health.fbarray.join(",");
                }
                if(this.health.qsarray!=null && this.health.qsarray.length>0){
                    obj.qs=this.health.qsarray.join(",");
                }
                if(this.health.mnxtarray!=null && this.health.mnxtarray.length>0){
                    obj.mnxt=this.health.mnxtarray.join(",");
                }
                if(this.health.fkarray!=null && this.health.fkarray.length>0){
                    obj.fk=this.health.fkarray.join(",");
                }
                if(this.health.qtzzarray!=null && this.health.qtzzarray.length>0){
                    obj.qtzz=this.health.qtzzarray.join(",");
                }
                if(this.health.ggjlarray!=null && this.health.ggjlarray.length>0){
                    obj.ggjl=this.health.ggjlarray.join(",");
                }
                if(this.health.nkarray!=null && this.health.nkarray.length>0){
                    obj.nk=this.health.nkarray.join(",");
                }
                if(this.health.nkjbarray!=null && this.health.nkjbarray.length>0){
                    obj.nkjb=this.health.nkjbarray.join(",");
                }
                if(this.health.fkjbarray!=null && this.health.fkjbarray.length>0){
                    obj.fkjb=this.health.fkjbarray.join(",");
                }
                if(this.health.ekjbarray!=null && this.health.ekjbarray.length>0){
                    obj.ekjb=this.health.ekjbarray.join(",");
                }
                if(this.health.smqkarray!=null && this.health.smqkarray.length>0){
                    obj.smqk=this.health.smqkarray.join(",");
                }
                this.$postw("beautymanager/saveHealth",obj).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message:"保存成功",
                            type:"success"
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            saveSkinTesting(){
                let obj=new Object();
                obj.storeid=this.storeid;
                obj.cardid=this.cardid;
                obj.memberid=this.memberid;
                obj.skinzk="";
                obj.et="";
                obj.yb="";
                obj.mj="";
                obj.bz="";
                obj.jb="";
                obj.skinzkother=this.skinTesting.skinzkother;
                obj.etother=this.skinTesting.etother;
                obj.ybother=this.skinTesting.ybother;
                obj.mjother=this.skinTesting.mjother;
                obj.bzother=this.skinTesting.bzother;
                obj.jbother=this.skinTesting.jbother;
                if(this.skinTesting.skinzkarray!=null && this.skinTesting.skinzkarray.length>0){
                    obj.skinzk=this.skinTesting.skinzkarray.join(",");
                }
                if(this.skinTesting.etarray!=null && this.skinTesting.etarray.length>0){
                    obj.et=this.skinTesting.etarray.join(",");
                }
                if(this.skinTesting.ybarray!=null && this.skinTesting.ybarray.length>0){
                    obj.yb=this.skinTesting.ybarray.join(",");
                }
                if(this.skinTesting.mjarray!=null && this.skinTesting.mjarray.length>0){
                    obj.mj=this.skinTesting.mjarray.join(",");
                }
                if(this.skinTesting.bzarray!=null && this.skinTesting.bzarray.length>0){
                    obj.bz=this.skinTesting.bzarray.join(",");
                }
                if(this.skinTesting.bzarray!=null && this.skinTesting.bzarray.length>0){
                    obj.jb=this.skinTesting.jbarray.join(",");
                }
                obj.gms=this.skinTesting.gms;
                obj.mbhlyq=this.skinTesting.mbhlyq;
                this.$postw("beautymanager/saveSkinTesting",obj).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message:"保存成功",
                            type:"success"
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });

            },
            getHealthById(){
                this.$post("beautymanager/getHealthById",{storeid:this.storeid,memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null){
                            this.health.storeid=obj.storeid;
                            this.health.cardid=obj.cardid;
                            this.health.memberid=obj.memberid;
                            this.health.qtjb=obj.qtjb;
                            this.health.stxq=obj.stxq;
                            this.health.bm=obj.bm;
                            this.health.bx=obj.bx;
                            this.health.tbother=obj.tbother;
                            this.health.xbother=obj.xbother;
                            this.health.fbother=obj.fbother;
                            this.health.qsother=obj.qsother;
                            this.health.mnxtother=obj.mnxtother;
                            this.health.fkother=obj.fkother;
                            this.health.qtzzother=obj.qtzzother;
                            this.health.ggjlother=obj.ggjlother;
                            this.health.nkother=obj.nkother;
                            this.health.nkjbother=obj.nkjbother;
                            this.health.fkjbother=obj.fkjbother;
                            this.health.ekjbother=obj.ekjbother;
                            this.health.smqkother=obj.smqkother;
                            if(obj.tb){
                                this.health.tbarray=obj.tb.split(",");
                            }
                            if(obj.xb){
                                this.health.xbarray=obj.xb.split(",");
                            }
                            if(obj.fb){
                                this.health.fbarray=obj.fb.split(",");
                            }
                            if(obj.qs){
                                this.health.qsarray=obj.qs.split(",");
                            }
                            if(obj.mnxt){
                                this.health.mnxtarray=obj.mnxt.split(",");
                            }
                            if(obj.fk){
                                this.health.fkarray=obj.fk.split(",");
                            }
                            if(obj.qtzz){
                                this.health.qtzzarray=obj.qtzz.split(",");
                            }
                            if(obj.ggjl){
                                this.health.ggjlarray=obj.ggjl.split(",");
                            }
                            if(obj.nk){
                                this.health.nkarray=obj.nk.split(",");
                            }
                            if(obj.nkjb){
                                this.health.nkjbarray=obj.nkjb.split(",");
                            }
                            if(obj.fkjb){
                                this.health.fkjbarray=obj.fkjb.split(",");
                            }
                            if(obj.ekjb){
                                this.health.ekjbarray=obj.ekjb.split(",");
                            }
                            if(obj.smqk){
                                this.health.smqkarray=obj.smqk.split(",");
                            }
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getSkinTestingById(){
                this.$post("beautymanager/getSkinTestingById",{storeid:this.storeid,memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null){
                            //this.skinTesting=obj;
                            this.skinTesting.storeid=obj.storeid;
                            this.skinTesting.cardid=obj.cardid;
                            this.skinTesting.memberid=obj.memberid;
                            this.skinTesting.gms=obj.gms;
                            this.skinTesting.mbhlyq=obj.mbhlyq;
                            this.skinTesting.skinzkother=obj.skinzkother;
                            this.skinTesting.etother=obj.etother;
                            this.skinTesting.ybother=obj.ybother;
                            this.skinTesting.mjother=obj.mjother;
                            this.skinTesting.bzother=obj.bzother;
                            this.skinTesting.jbother=obj.jbother;
                            if(obj.skinzk){
                                this.skinTesting.skinzkarray=obj.skinzk.split(",");
                            }
                            if(obj.et){
                                this.skinTesting.etarray=obj.et.split(",");
                            }
                            if(obj.yb){
                                this.skinTesting.ybarray=obj.yb.split(",");
                            }
                            if(obj.mj){
                                this.skinTesting.mjarray=obj.mj.split(",");
                            }
                            if(obj.bz){
                                this.skinTesting.bzarray=obj.bz.split(",");
                            }
                            if(obj.jb){
                                this.skinTesting.jbarray=obj.jb.split(",");
                            }
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            handleClick(name){
                if(this.active==1){
                    if(this.isloadst==false){
                        this.getSkinTestingById();
                        this.getHealthById();
                        this.isloadst=true;
                    }
                }
                else if(this.active==2){
                    if(this.isloadxsxj==false){
                        //this.getCardTransactionhistoryByCardId();
                        this.getCardTransactionhistoryByCardIdPage();
                        this.isloadxsxj=true;
                    }
                }
                else if(this.active==3){
                    if(this.isbeautyserver==false){
                        this.isbeautyserver=true;
                        this.getBeautyServerById();
                    }
                }
                else if(this.active==4){
                    //this.queryBeautyXfTask();
                    this.getCardtransactionhistoryByCash();
                }
            },
            updateMemberInfo(){
                this.$postw("cardinfo/updateMemberInfo",this.memberInfo).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message:"修改成功",
                            type:"success"
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getMemberInfoById(){
                this.$post("cardinfo/getMemberInfoById",{memberid:this.memberid}).then(res=>{
                    if(res.sucess){
                        this.memberInfo=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyXfProjectTypeExperienceByCardId(){
                this.$post("beautymanager/getBeautyXfProjectTypeExperienceByCardId",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.projectExperienceTypes=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyXfProjectTypeByCardId(){
                this.$post("beautymanager/getCardCourseByFinishType",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.projectTypes=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardCourseByCardId(){
                this.$post("cardinfo/getCardCourseByCardId",{cardid:this.cardid,showRest:0}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                if(val.projectbigtype==2){
                                    this.cardCourses.push(val);
                                }
                            }
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardAccountByCardId(){
                this.$post("cardinfo/getCardAccountByCardId",{cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.cardAccounts=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getMinDate(){
                this.$post("beautymanager/getMinDate",{cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.mldate=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyMinDate(){
                this.$post("beautymanager/getBeautyMinDate",{cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        this.beautydate=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getCardInfoByCardNumberUnsold(){
                this.$post("cardinfo/getCardInfoByCardNumberNormal",{storeid:this.storeid,cardnumber:this.cardnumber}).then(res=>{
                    if(res.sucess){
                        this.cardInfoVo=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .beautymemberinfo .el-divider--horizontal{
        margin:12px 0;
    }

    .pfzk .el-form-item__content{
        line-height:20px;
    }

    .pfzk .el-input__inner{
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
        border-radius:0px;
    }

    .pfzk .el-form-item{
        margin-bottom:0px;
    }

    .pfzk{
        margin-bottom: 50px;
    }

    .xsxj .el-radio{
        margin-right:5px;
    }


    :after td{
        padding: 12px 1px;
    }

    .xsxj .el-descriptions-row .el-descriptions .is-bordered .el-descriptions-item__cell{
        padding: 12px 1px;
    }

    .mycard .el-card__header{
        background-color: rgb(238, 241, 246)
    }

    .mycard .el-card__body{
        padding: 5px;
    }

    .mycard .el-form-item{
        margin-bottom:0px;
    }

    .myboxcard .el-card__body{
        padding:5px;
    }

    .myfrom .el-form-item{
        margin-bottom:0px;
    }
</style>



// WEBPACK FOOTER //
// src/page/beauty/beautymemberinfo.vue